import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { UnorderedList as UnorderedList$1 } from '@vds/core';
import styles from './unordered-list.module.scss.js';
import Text from '../../typography/text/index.js';

const UnorderedList = (_a) => {
    var { glyphs, leadInText, surface, spacing = 'standard', size = 'large' } = _a, rest = __rest(_a, ["glyphs", "leadInText", "surface", "spacing", "size"]);
    const unorderedListWrapperStyles = [
        styles.unorderedWrapper,
        styles[size],
        styles[spacing],
    ];
    const leadInTextStyles = [styles.leadInText, styles[spacing], styles[size]];
    if (glyphs === null || glyphs === void 0 ? void 0 : glyphs.hidden)
        unorderedListWrapperStyles.push(styles.hideGlyphs);
    // For trailingtooltip
    const _getLeadInText = () => (jsx("div", { className: leadInTextStyles.join(' '), children: jsx(Text, Object.assign({ primitive: "span", kind: (leadInText === null || leadInText === void 0 ? void 0 : leadInText.size) === 'micro' ? 'micro' : 'body', bold: !!(leadInText === null || leadInText === void 0 ? void 0 : leadInText.bold), size: (leadInText === null || leadInText === void 0 ? void 0 : leadInText.size) === 'micro' ? 'small' : (leadInText === null || leadInText === void 0 ? void 0 : leadInText.size) || 'large', color: leadInText === null || leadInText === void 0 ? void 0 : leadInText.color }, ((leadInText === null || leadInText === void 0 ? void 0 : leadInText.tooltip) && {
            tooltip: Object.assign({ surface, size: (leadInText === null || leadInText === void 0 ? void 0 : leadInText.size) === 'micro' || (leadInText === null || leadInText === void 0 ? void 0 : leadInText.size) === 'small'
                    ? 'small'
                    : 'medium' }, leadInText.tooltip),
        }), { children: leadInText === null || leadInText === void 0 ? void 0 : leadInText.children })) }));
    return (jsxs("div", { className: unorderedListWrapperStyles.join(' '), children: [leadInText && _getLeadInText(), jsx(UnorderedList$1, Object.assign({ color: "primary", surface: surface }, rest, { size: size, spacing: spacing === 'comfortable' ? 'standard' : spacing }))] }));
};

export { UnorderedList as default };
